import ContactForm from "./ContactForm"
import ContactHeader from "./ContactHeader"
import Footer from "../../shared/Footer"

function Contact() {
  return (
    <>
        <ContactHeader />
        <ContactForm />
        <Footer />
    </>
  )
}

export default Contact